<ion-row class="p0">
<ion-col class="content-padding" size-xl="6" size-lg="6" size-md="6" size-sm="6" size-xs="6">
    <div class = "jobPosition">
      <div class = "static-select-width" [ngClass]="{'alter-padding': !isMultiPatientAllowed}">
        <ion-select [disabled]="!availablePatients.length" [compareWith]="comparePatients"
  [(ngModel)]="selectedPatient" class="position select-font" placeholder="Select Patient"
  [interfaceOptions]="interfaceOptions" (ionChange)="handlePatientIdChange()">
          <ion-select-option class = "options" [value]="patient" *ngFor="let patient of availablePatients; trackBy:trackByPatient">
            {{patient.id}}
          </ion-select-option>
        </ion-select>
        <i class = "fa fa-chevron-down"></i>
      </div>
    </div>
  </ion-col>
  <ion-col class="content-padding" [ngClass] = "{'align-column': currentView === 'broadcast-request'}" size-xl="6" size-lg="6" size-md="6" size-sm="6" size-xs="6">
    <div class = "jobPosition">
      <div class = "full-col-width">
        <app-places-autocomplete [ngClass]="{'create-shift': currentView === 'create-shift', 'broadcast-request': currentView === 'broadcast-request', 'input-error': showAddressError}" [formatedAddress]="displayAddress" class="style-broadcast" [currentView] = "currentView" [isMultiPatientAllowed] =  "true" (addressChanged)="handleAddressChange($event)"></app-places-autocomplete>
        <p *ngIf="showAddressError" class="error-text">Address / postal code is required</p>
      </div>
    </div>
  </ion-col>
</ion-row>